// Jornadas de exemplo enquanto o backend não existe.
//
// NOTA: Indexado por clientId, com derivação determinística para quem não está no
// mapa. A base real tem mais de mil clientes: sem o fallback derivado, 99% das
// linhas da lista viriam vazias e a coluna Jornada pareceria quebrada.
import { JOURNEY_TEMPLATE_DEFAULT } from '@modules/client-journey/constants/journey-template-default'
import { JOURNEY_STATUS } from '@modules/client-journey/constants/Text'

const { CONCLUIDA, EM_ANDAMENTO, PENDENTE, BLOQUEADA } = JOURNEY_STATUS

// Monta as 6 etapas com os N primeiros passos concluídos, contando na ordem do
// template — assim o mock nunca inventa etapa nem sai da ordem canônica.
function montarStages(passosConcluidos) {
  let restantes = passosConcluidos
  let jaAbriuAtual = false

  return JOURNEY_TEMPLATE_DEFAULT.stages.map((stage) => {
    const steps = stage.steps.map((step) => {
      if (restantes > 0) {
        restantes -= 1
        return { stepId: step.id, status: CONCLUIDA, completedAt: '2026-07-23', blockedReason: null }
      }
      if (!jaAbriuAtual) {
        jaAbriuAtual = true
        return { stepId: step.id, status: EM_ANDAMENTO, completedAt: null, blockedReason: null }
      }
      return { stepId: step.id, status: BLOQUEADA, completedAt: null, blockedReason: null }
    })

    const feitos = steps.filter((s) => s.status === CONCLUIDA).length
    const temAtual = steps.some((s) => s.status === EM_ANDAMENTO)
    let status = PENDENTE
    if (feitos === steps.length) status = CONCLUIDA
    else if (temAtual || feitos > 0) status = EM_ANDAMENTO
    else status = stage.kind === 'recorrente' ? BLOQUEADA : PENDENTE

    return {
      stageId: stage.id,
      status,
      completedAt: status === CONCLUIDA ? '2026-07-23' : null,
      slaDueAt: null,
      progressPercent: Math.round((feitos / steps.length) * 100),
      steps,
    }
  })
}

const cliente = (clientId, { passos, semInteracao, atrasoSla, patrimonio }) => ({
  clientId,
  templateId: JOURNEY_TEMPLATE_DEFAULT.id,
  templateVersion: JOURNEY_TEMPLATE_DEFAULT.version,
  stages: montarStages(passos),
  signals: {
    daysWithoutInteraction: semInteracao,
    lastInteractionAt: '2026-07-23',
    slaOverdueDays: atrasoSla,
    patrimonio,
    inEntryPipeline: passos < 3,
  },
})

// Os mesmos clientes do protótipo aprovado, para a tela bater com o desenho.
export const JOURNEY_CLIENTS_MOCK = [
  cliente(12401, { passos: 6, semInteracao: 6, atrasoSla: 2, patrimonio: 6800000 }),
  cliente(12377, { passos: 2, semInteracao: 9, atrasoSla: 0, patrimonio: 2400000 }),
  cliente(12290, { passos: 9, semInteracao: 5, atrasoSla: -1, patrimonio: 4100000 }),
  cliente(12255, { passos: 9, semInteracao: 12, atrasoSla: -8, patrimonio: 5500000 }),
  cliente(12348, { passos: 5, semInteracao: 2, atrasoSla: -2, patrimonio: 1900000 }),
  cliente(12389, { passos: 7, semInteracao: 1, atrasoSla: -5, patrimonio: 3200000 }),
  cliente(12412, { passos: 1, semInteracao: 3, atrasoSla: -9, patrimonio: 850000 }),
  cliente(12420, { passos: 0, semInteracao: 1, atrasoSla: -12, patrimonio: 1200000 }),
]

const POR_ID = JOURNEY_CLIENTS_MOCK.reduce((acc, c) => {
  acc[c.clientId] = c
  return acc
}, {})

// Cliente fora do mapa: jornada derivada do próprio id, estável entre recargas
// (o mesmo cliente cai sempre no mesmo ponto da esteira). Serve só para a tela
// ter volume realista — nada aqui pretende ser dado verdadeiro.
function derivarPorId(clientId) {
  const n = Math.abs(Number(clientId) || 0)
  return cliente(clientId, {
    passos: n % 12,
    semInteracao: n % 15,
    atrasoSla: (n % 9) - 4,
    patrimonio: 150000 + (n % 40) * 175000,
  })
}

export function jornadaMockDoCliente(clientId) {
  return POR_ID[clientId] || derivarPorId(clientId)
}
